<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.4416 8.44159L15.3725 9.51067L17.1059 11.244H4V12.7559H17.1059L15.3725 14.4893L16.4416 15.5584L20 12L16.4416 8.44159Z"
      class="fill-current"
    />
  </svg>
</template>
